var GenericView = require('views/generic.view.ts');
var _ = require("underscore");
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/analysis.template.html');

var TheView = GenericView.extend({
    el: '#analysis',
    tagName: '',
	template: Handlebars.compile(Template),
	fields: [],
	initialize: function (options) {
        this.render();
        GenericView.prototype.storeView(this, "analysis");
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template);
    },
    events: {
        "input .to-validation input": "validateIt",
        "click #collapseDescription": "collapseDescription"
    },
    validateIt: _.debounce(
        function(event)
        {
            var element = $(event.currentTarget);
            this.validateSingleField(element);
        },
    300),
    collapseDescription: function(event) {
        var btn = event.currentTarget;
        GenericView.prototype.collapseDescription(btn);
    },
    getAllData: function() {
        var iter_exh = $("input[name='analysis_method']:checked").hasClass("examination9") ? 4 : 81;

        var data = {
            targetType: $("input[name='analysis_method']:checked").val(),
            n_max: this.convertToInt("#n_max"),
            timeStep: 15,
            iter_exh: iter_exh,
            iter_pso: 100
        };

        return data;
    }
});

module.exports= TheView;